import { Component, EventEmitter, Output } from '@angular/core';
import { IntegracaoConstants } from 'src/app/constants/integracao';
import { FiltroControllerService } from 'src/app/services/filtro-controller.service';
import { ModulosDeFormulario } from 'src/app/utils/formsModules';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'filtro-config-seguradoras',
    templateUrl: './config-seguradoras.component.html',
    styleUrls: ['./config-seguradoras.component.scss'],
    imports: [CommonModule, ModulosDeFormulario],
})
export class ConfigSeguradorasComponent {
  public _RAMOS = IntegracaoConstants.ramosArray;
  public filtrarRamos =  this.filtroController.filtroSeguradoras?.ramos ?? [];

  @Output('eventFilter') eventFilter = new EventEmitter();
  @Output('clearFilter') limpaFiltro = new EventEmitter();

  constructor(
    private filtroController: FiltroControllerService,
  ) {
  }
  
  clearFilter() {
    this.filtroController.updateActiveFilters("config-seg", 0);
    this.filtrarRamos = [];
    this.filtroController.limparFiltro('seguradoras');
    this.limpaFiltro.emit()
    this.filtroController.verificaFiltro();
    this.buildString();
  }
  
  buildString(oculto?: boolean) {
    let jsonEnvio = {
      ramos: this.filtrarRamos
    }

    let filtros = { values: jsonEnvio }
    this.filtroController.addFiltrosExtras('config-seguradoras', filtros)
    this.eventFilter.emit(filtros);
    
    return filtros;
  }

  updateFiltroRamo(ramo){
    if (this.filtrarRamos.includes(ramo)) {
      this.filtrarRamos = this.filtrarRamos.filter(item => item !== ramo);
      
      this.filtroController.updateActiveFilters("config-seg", this.filtrarRamos.length);

      return;
    } 
    
    this.filtrarRamos.push(ramo);

    this.filtroController.updateActiveFilters("config-seg", this.filtrarRamos.length);
  }
}
